import axios from 'axios';
import React from 'react'
import Swal from 'sweetalert2';
import { BASE_URL } from 'utils/constants';

const LeaveTeam = (props) => {
    const LeaveTeamFn = () => {
        Swal.fire({
            title: 'Are you sure you want to leave this team ?',
            showDenyButton: true,
            confirmButtonText: `Leave`,
            denyButtonText: `Cancel`,
        }).then((result) => {
            /* Read more about isConfirmed, isDenied below */
            if (result.isConfirmed) {
                Swal.showLoading();
                axios.post(`${BASE_URL}/capstone/teamformation/leaveteam.php`, {})
                    .then(res => {
                        // console.log("res")
                        // console.log(res)
                        props.setInGroup(false);
                        props.setTeamName("");
                        props.setTeamMembers([]);
                        Swal.fire('Left successfully!', '', 'success')
                    }).catch(err => {
                        Swal.fire(err?.response?.data?.msg || "We couldn't remove you from the team. Please try again.", "", "warning")
                        // Swal.fire('Changes are not saved', '', 'info');
                    })
            } else if (result.isDenied) {
                //   Swal.fire('Changes are not saved', '', 'info');
            }
        });
        // // console.log("LeaveTeam")
    }
    return (
        <button className='btn btn-danger' onClick={LeaveTeamFn} >Leave Team</button>
    )
}

export default LeaveTeam
